{
  "backgroundColor": "transparent",
  "tooltip": {
    "trigger": "item",
    "formatter": "{a} <br/>{b}: {c} Hunts"
  },
  "series": {
    "name": null,
    "radius": ["15%", "90%"],
    "type": "sunburst",
    "emphasis": {
      "focus": "ancestor"
    },
    "data": [],
    "label": {
      "rotate": "radial"
    },
    "levels": [],
    "itemStyle": {
      "color": "#ddd",
      "borderWidth": 2,
      "borderRadius": 5
    }
  }
}
